import './src/styles/global.css';

import PageWrapper from './src/components/PageWrapper';
import RootProvider from './src/RootProvider';

export const wrapRootElement = RootProvider;
export const wrapPageElement = PageWrapper;
